var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"both",on:{"click":_vm.toggle}},[_c('div',{staticClass:"option",class:_vm.style1},[_vm._v(_vm._s(_vm.option1))]),_c('div',{staticClass:"option",class:_vm.style2},[_vm._v(_vm._s(_vm.option2))])])
}
var staticRenderFns = []

export { render, staticRenderFns }